import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		headerContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			marginBottom: theme.spacing(3),
			flexWrap: "wrap",
			gap: theme.spacing(2),
			[theme.breakpoints.down("sm")]: {
				flexDirection: "column",
				alignItems: "stretch",
			},
		},
		leftSection: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			flex: 1,
			[theme.breakpoints.down("sm")]: {
				width: "100%",
			},
		},
		searchBar: {
			backgroundColor: "white",
			border: "1px solid #ebebeb",
			borderRadius: 4,
			padding: theme.spacing(1, 2),
			height: 48,
			width: 464,
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1.25),
			[theme.breakpoints.down("sm")]: {
				flex: 1,
				width: "auto",
			},
			"& input": {
				padding: 0,
				fontSize: 16,
				lineHeight: "24px",
				fontFamily: theme.typography.fontFamily,
				color: theme.palette.custom.textSecondary,
				"&::placeholder": {
					color: theme.palette.custom.textSecondary,
					opacity: 1,
				}
			}
		},
		searchIcon: {
			width: 24,
			height: 24,
			color: theme.palette.custom.textSecondary,
		},
		button: {
			backgroundColor: "white",
			border: `1px solid ${theme.palette.primary.main}`,
			borderRadius: 4,
			height: 48,
			padding: theme.spacing(1.25),
			fontSize: 16,
			lineHeight: 1.2,
			fontFamily: theme.typography.fontFamily,
			fontWeight: 500,
			color: theme.palette.primary.main,
			textTransform: "none" as const,
			"&:hover": {
				backgroundColor: "white",
			},
		},
		sortButton: {
			[theme.breakpoints.down("sm")]: {
				display: "none",
			},
		},
		sortIcon: {
			width: 24,
			height: 24,
			color: theme.palette.primary.main,
		},
		filterButton: {
			minWidth: 48,
			padding: theme.spacing(1.25),
			[theme.breakpoints.down("sm")]: {
				width: 48,
			},
		},
		filterIcon: {
			display: "none",
			[theme.breakpoints.down("sm")]: {
				display: "inline-flex",
			},
		},
		filterText: {
			display: "inline-flex",
			[theme.breakpoints.down("sm")]: {
				display: "none",
			},
		},
		addButton: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
			border: "none",
			"&:hover": {
				backgroundColor: theme.palette.primary.main,
			},
			[theme.breakpoints.down("sm")]: {
				width: "100%",
			},
		},
		rightSection: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			[theme.breakpoints.down("sm")]: {
				width: "100%",
				flexDirection: "column",
			},
		},
	} satisfies Record<string, CSSObject>;
};
